<template>
  <div>
    <OrganizationsContextCard />
    <v-container
      v-if="getSelectedResourceSecond !== null"
      class="location--overview--context__container pa-0"
    >
      <v-row :key="selectedLocation.id" class="pa-0 pt-2 location--overview--context__layout" no-gutters>
        <!-- TODO: add to i18n -->
        <v-col>
        <!-- <v-row no-gutters> -->
          <ContextItemEditableInput
            :icon="'fas fa-bullseye'"
            :iconTooltip="$t('locations.location_name')"
            :eventName="'click'"
            :value="selectedLocation.name"
            :emptyValue="`${$t('locations.add')} ${$t('locations.location_name')}`"
            @save-emitted="editLocationName"
            :savedByEnter="true"
          />
        <!-- </v-row> -->
         <!-- <v-row no-gutters> -->
           <ContextItemAutoComplete
              :eventName="'click'"
              :iconTooltip="$t('locations.type')"
              :icon="'fas fa-map-pin'"
              :value="selectedLocation.type"
              translate="locations"
              :emptyValue="`${$t('locations.add')} ${$t('locations.type')}`"
              @autocompleteSave="handleEditLocationType"
              :list="computedLocationsAvailableTypes"
            />
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <ContextItem
            :iconTooltip="$t('locations.address')"
            :icon="'fas fa-map-marker-alt'"
            :attribute="locationAddress.address === '' ? 'Not Defined' : locationAddress.address | AddressObjectToString([['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])"
            :actionIcons="{edit: 'custom', copy: computedCopyAddress}"
            :eventName="'click'"
            @customEditEmitted="handleEditLocation"
          >
          </ContextItem>
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <ContextItemEditableInput
            v-if="selectedLocation.ref == ''"
            :icon="'fas fa-link'"
            :iconTooltip="$t('organizations.ref')"
            :eventName="'click'"
            :value="selectedLocation.ref"
            :emptyValue="`${$t('locations.add')} ${$t('locations.ref')}`"
            :savedByEnter="true"
            @save-emitted="handleUpdateReference"
          />
          <ContextItemNoEditable
            v-else
            :icon="'fas fa-link'"
            :iconTooltip="$t('locations.ref')"
            :attribute="selectedLocation.ref"
            :isCopyable="true"
          />
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <ContextItemAutoComplete
              :eventName="'click'"
              :icon="'fas fa-truck-loading'"
              :iconTooltip="$t('locations.accessibility')"
              translate="accessibility"
              :value="selectedLocation.accessibility"
              :emptyValue="`${$t('locations.add')} ${$t('locations.accessibility')}`"
              @autocompleteSave="handleSaveAccessibility"
              :list="computedLocationsAvailableAccessibility"
            />
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <ContextItemLabels
            :isEditable="true"
            :icon="'fas fa-tools'"
            :iconTooltip="$t('locations.equipment')"
            :labels="computedLocationEquipment"
            :emptyLabel="`${$t('locations.add')} ${$t('locations.equipment')}`"
            :eventName="'click'"
            @handleSaveLabels="handleSaveEquipment"
            :algoliaSearchLabels="null"
            :allowCustomLabels="false"
            :labelsList="locationsAvailableEquipment"
            translate="equipment"
          />
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <LocationsOpeningHours :location="selectedLocation" />
        <!-- </v-row> -->
        <!-- <v-row no-gutters> -->
          <LocationsContacts :location="selectedLocation" :contacts="selectedLocation.contactPersons" />
        <!-- </v-row> -->
        <!-- <ContextItem
          :iconTooltip="'Location Name'"
          :icon="'fas fa-bullseye'"
          :attribute="selectedLocation.name"
          @input-attribute="editLocationName"
          :hideAttributeOnEdit="true"
          :eventName="'click'"
          :actionIcons="{edit: 'normal', copy: selectedLocation.name}"
        /> -->
        <!-- <LocationsAddressEdit :address="selectedLocation.address" /> -->


        <!-- TODO: add to i18n -->
        <!-- <ContextItemLabels
          :isEditable="true"
          :icon="'fas fa-truck-loading'"
          :iconTooltip="$t('locations.accessibility')"
          :labels="computedLocationAccessibility"
          :emptyLabel="`${$t('locations.add')} ${$t('locations.accessibility')}`"
          :eventName="'click'"
          @handleSaveLabels="handleSaveAccessibility"
          :algoliaSearchLabels="null"
        />
        <ContextItemLabels
          :isEditable="true"
          :icon="'fas fa-tools'"
          :iconTooltip="$t('locations.equipment')"
          :labels="computedLocationEquipment"
          :emptyLabel="`${$t('locations.add')} ${$t('locations.equipment')}`"
          :eventName="'click'"
          @handleSaveLabels="handleSaveEquipment"
          :algoliaSearchLabels="null"
        /> -->
        </v-col>
      </v-row>
      <AddLocation :key="editLocationKey" :openMenu="editLocationMenu" @close="editLocationMenu = false" :editableAddress="locationAddress.address" :editableCoordinates="locationAddress.coordinates" :isEditing="true"
      @location-edited="handleEditLocationAddress"
      />
    </v-container>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { uuid } from 'vue-uuid'
import { locationService } from '@/_services'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels'
import ContextItemEditableInput from '@/components/wrld/generic/ContextItemEditableInput'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable'
import LocationsOpeningHours from '@/components/organizations/locations/LocationsOpeningHours.vue'
import ContextItem from '@/components/wrld/generic/ContextItem'
// import LocationsAddressEdit from '@/components/organizations/locations/LocationsAddressEdit.vue'
import AddLocation from '@/components/organizations/locations/AddLocation'
import LocationsContacts from '@/components/organizations/locations/LocationsContacts.vue'
import OrganizationsContextCard from '@/components/organizations/OrganizationsContextCard'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete'

export default {
  name: 'LocationsOverviewContext',
  components: {
    LocationsOpeningHours,
    LocationsContacts,
    ContextItemLabels,
    ContextItemEditableInput,
    OrganizationsContextCard,
    ContextItemNoEditable,
    ContextItem,
    AddLocation,
    ContextItemAutoComplete
  },
  props: {},
  data () {
    return {
      addressFormDialogOpen: false,
      editLocationMenu: false,
      editLocationKey: null,
      locationsAvailableTypes: [],
      locationsAvailableAccessibilty: [],
      locationsAvailableEquipment: []
    }
  },
  created() {
    locationService.getLocationTypeEnum().then((response) => {
      this.locationsAvailableTypes = response.map(({ name }) => {
        return {
          text: name,
          type: name,
          id: name
        }
      })
    })
    locationService.getLocationAccessibilityEnum().then((response) => {
      this.locationsAvailableAccessibilty = response.map(({ name }) => {
        return {
          text: name,
          accessibility: name,
          id: name
        }
      })
    })
    locationService.getLocationEquipmentEnum().then((response) => {
      this.locationsAvailableEquipment = response.map(({ name }) => {
        return name
      })
    })

  },
  computed: {
    ...mapGetters(['getSelectedResource', 'getSelectedResourceSecond', 'getOrganizationResourceDetails']),
    organization () {
      return {
        ...this.getOrganizationResourceDetails,
        openHours: {
          from: '8:00',
          to: '17:00'
        },
        labels: [],
        logo: 'climax.png'
      }
    },
    selectedLocation () {
      return this.getSelectedResourceSecond
    },
    locationAddress () {
      return this.selectedLocation
    },
    computedLocationEquipment () {
      let locationEquipment = []
      if (this.selectedLocation.equipment !== null) {
        this.selectedLocation.equipment.forEach((label) => {
          locationEquipment.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return locationEquipment
    },
    computedLocationAccessibility () {
      let locationAccessibility = []
      if (this.selectedLocation.accessibility !== null) {
        this.selectedLocation.accessibility.forEach((label) => {
          locationAccessibility.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return locationAccessibility
    },
    computedCopyAddress () {
      return this.$options.filters.AddressObjectToString(this.locationAddress.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])
    },
    computedLocationsAvailableTypes () {
      return this.locationsAvailableTypes
    },
    computedLocationsAvailableAccessibility () {
      return this.locationsAvailableAccessibilty
    }
  },
  methods: {
    ...mapActions({
      updateResourceSecond: 'updateResourceSecond',
      setLocationName: 'setLocationName',
      updateSecondResourceOverviewList: 'updateSecondResourceOverviewList',
      setLocationAddress: 'setLocationAddress',
      setLocationCoordinates: 'setLocationCoordinates',
      setLocationType: 'setLocationType',
      setLocationAccessibility: 'setLocationAccessibility',
      setLocationEquipment: 'setLocationEquipment',
      setLocationReference: 'setLocationReference'
    }),
    editLocationName (value) {
      this.updateSecondResourceOverviewList({
        item: { ...this.selectedLocation, name: value }
      })
      this.updateResourceSecond({
        resource: { ...this.selectedLocation, name: value }
      })
      this.setLocationName({ locationID: this.selectedLocation.id, name: value })
    },
    handleSaveEquipment (equipment) {
      const newEquipments = equipment.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.selectedLocation.equipment != null) {
        this.selectedLocation.equipment.forEach((label) => {
          if (newEquipments.indexOf(label) < 0) {
            remove.push(label)
          }
        })
      }
      newEquipments.forEach((label) => {
        if (this.selectedLocation.equipment != null) {
          if (this.selectedLocation.equipment.indexOf(label) < 0) {
            add.push(label)
          }
        } else {
          add.push(label)
        }
      })
      this.setLocationEquipment({
        location: { ...this.selectedLocation, equipment: newEquipments },
        locationID: this.selectedLocation.id,
        add,
        remove
      })
    },
    handleSaveAccessibility ({ accessibility }) {
      this.setLocationAccessibility({
        location: { ...this.selectedLocation, accessibility },
        locationID: this.selectedLocation.id,
        accessibility
      })
    },
    handleEditLocation () {
      this.editLocationKey = uuid.v1()
      this.$nextTick(() => {
        this.editLocationMenu = true
      })
    },
    handleEditLocationAddress ({ address, coordinates }) {
      this.updateSecondResourceOverviewList({
        item: { ...this.selectedLocation, address, coordinates }
      })
      this.updateResourceSecond({
        resource: { ...this.selectedLocation, address, coordinates }
      })
      this.setLocationAddress({ locationID: this.selectedLocation.id, oldVal: { ...this.selectedLocation.address }, address })
      this.setLocationCoordinates({ locationID: this.selectedLocation.id, oldVal: { ...this.selectedLocation.coordinates }, coordinates })
    },
    handleEditLocationType ({ type }) {
      this.setLocationType({
        location: { ...this.selectedLocation, type },
        locationID: this.selectedLocation.id,
        type
      })
    },
    handleUpdateReference (value) {
      this.setLocationReference({
        location: { ...this.selectedLocation, ref: value },
        locationID: this.selectedLocation.id,
        reference: value
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.location--overview--context__container {
  margin-top: 5px;
  // border-top: 1px solid lightgray;
}
</style>
